import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM8 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM4 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM1.09 5h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H1.09C.489 7 0 6.552 0 6s.488-1 1.09-1Zm0 5h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H1.09C.489 12 0 11.552 0 11s.488-1 1.09-1Z",
  fill: "$green",
  "fill-rule": "nonzero"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };